module.exports = __webpack_public_path__ + "static/media/inactiveUser.29479ba0.png";